import Axios from 'axios'

const client = {
  getClients () {
    return Axios.get(`api/suppliers/clients`)
  }
}

export default client
